import React, {useState, useEffect, useContext} from "react";
import {FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Btn} from "../../../../../AbstractElements";
import WalletCustomAmountForm from "./WalletCustomAmountForm";
import axiosConfig from "../../../../../Config/axios";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import Loader from "../../../../../Layout/Loader";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

interface WalletTransactionModalProps {
    isOpen: boolean;
    toggle: () => void;
    wallet_owner_id: number;
    wallet_current_balance: number | undefined;
    transactionTypes: string[];
    onTransactionComplete: () => void;
    action?: string;
    attachmentRequired?: boolean;
}

const WalletTransactionModal: React.FC<WalletTransactionModalProps> = ({
                                                                           isOpen,
                                                                           toggle,
                                                                           action='Transfer',
                                                                           wallet_owner_id,
                                                                           wallet_current_balance,
                                                                           transactionTypes,
                                                                           onTransactionComplete,
                                                                           attachmentRequired=false
                                                                       }) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const [selectedTransactionType, setSelectedTransactionType] = useState<string>(
        transactionTypes.length > 0 ? transactionTypes[0] : ''
    );
    const [maximumAmount, setMaximumAmount] = useState<number>(0);
    const [maximumValidation, setMaximumValidation] = useState<boolean>(true);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler, authorizedUser} = authContext || {};

    useEffect(() => {
        if (!selectedTransactionType) return;
        switch (selectedTransactionType) {
            case 'transaction-type-point-purchase-collector-participant':
            case 'transaction-type-point-purchase-system-participant':
                setMaximumValidation(false);
                break;
            case 'transaction-type-cash-transfer-system-collector':
            case 'transaction-type-cash-withdraw-system-participant':
            case 'transaction-type-cash-withdraw-system-collector':
                setMaximumValidation(true);
                getWalletBalance({
                    relation_type: 'user',
                    relation_id: authorizedUser.id,
                    wallet_type: 'wallet-type-cash',
                });
                break;
            default:
                setMaximumValidation(true);
                setMaximumAmount(wallet_current_balance ?? 0);
        }
    }, [selectedTransactionType]);
    const getWalletBalance = (params: any) => {
        setLoaderVisibility(true);
        const config = {params: params};
        axiosConfig
            .get(getApplicationRoute('wallet'), config)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data.length) {
                    const walletData = response.data.data[0];
                    setMaximumAmount(Math.min(wallet_current_balance ?? 0, walletData.current_balance ?? 0));
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });

    }
    // Update selectedTransactionType when transactionTypes changes
    useEffect(() => {
        if (transactionTypes.length > 0 && !selectedTransactionType) {
            setSelectedTransactionType(transactionTypes[0]);
        }
    }, [transactionTypes, selectedTransactionType]);

    if (!wallet_owner_id) {
        return null;
    }

    // Function to format transaction type for display
    const formatTransactionTypeName = (type: string): string => {
        const formatted = type.replace(/-/g, ' ');
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader>
                Buy Points
            </ModalHeader>
            <ModalBody>
                <Loader visibility={loaderVisibility}/>
                <FormGroup>
                    <Label for="transactionType">Transaction Type</Label>
                    <Input
                        type="select"
                        id="transactionType"
                        value={selectedTransactionType}
                        onChange={(e) => setSelectedTransactionType(e.target.value)}
                    >
                        {transactionTypes.map((type) => (
                            <option key={type} value={type}>
                                {formatTransactionTypeName(type)}
                            </option>
                        ))}
                    </Input>
                </FormGroup>
                <div>
                    <WalletCustomAmountForm
                        action={action}
                        key={selectedTransactionType}
                        callBack={onTransactionComplete}
                        maxAmount={maximumAmount}
                        maximumValidation={maximumValidation}
                        impactorID={wallet_owner_id}
                        transactionType={selectedTransactionType}
                        attachmentRequired={attachmentRequired}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Btn
                    attrBtn={{
                        color: 'primary',
                        onClick: toggle
                    }}>Close</Btn>
            </ModalFooter>
        </Modal>
    );
};

export default WalletTransactionModal;


